import { useContext } from 'react'
import {
  GlobalLoadingActions,
  GlobalLoadingActionsContext,
  GlobalLoadingState,
  GlobalLoadingStateContext,
} from '@context/GlobalLoadingContext'

export function useGlobalLoadingActions(): GlobalLoadingActions {
  const ctx = useContext(GlobalLoadingActionsContext)
  if (!ctx)
    throw new Error(
      'useGlobalLoadingActions must be used within GlobalLoadingProvider',
    )
  return ctx
}

export function useGlobalLoadingState(): GlobalLoadingState {
  const ctx = useContext(GlobalLoadingStateContext)
  if (!ctx)
    throw new Error(
      'useGlobalLoadingState must be used within GlobalLoadingProvider',
    )
  return ctx
}
